import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import FuseTheme from '../global/theme';
import IconButton from 'material-ui/IconButton';
import ContentView from 'material-ui/svg-icons/image/remove-red-eye';

const styles = {
    icon: {overflow: 'inherit'},
};

const ViewButtonWithType = ({basePath = '', record = {}}) => (
    <IconButton
        containerElement={<Link to={`${basePath}/${encodeURIComponent(record.type)}/${record.id}/show`}/>}
        style={styles.icon}
    >
        <ContentView color={FuseTheme.palette.primary1Color}/>
    </IconButton>
);

ViewButtonWithType.propTypes = {
    basePath: PropTypes.string,
    record: PropTypes.object,
};

ViewButtonWithType.defaultProps = {
    style: {padding: 0},
};

export default ViewButtonWithType;


// WEBPACK FOOTER //
// ./src/Fuse/buttons/ViewButtonWithType.js